<template lang="pug">
#sidenav
  b-navbar.desktop.flex-column(sticky v-b-scrollspy:scrollspy-nested.200 )
    b-nav(vertical v-for='section in sections')
      b-nav-item.py-1(:href="'#'+ section.id") {{section.text}}
      b-nav.sub(vertical v-for='subsection in section.subsections')
        b-nav-item.pb-2(:href="'#'+ subsection.id" :class="subsection.id") {{subsection.text}}
      .border-btm

  b-navbar#mobilenav.mobile( toggleable="sm" v-b-scrollspy:scrollspy-nested.200)
    b-navbar-toggle.ml-auto(target="nav-text-collapse")
    b-collapse(id="nav-text-collapse")
      b-navbar-nav(v-for='section in sections')
        b-nav-item.py-2(:href="'#'+ section.id") {{section.text}}
        b-navbar-nav.sub(v-for='subsection in section.subsections')
          b-nav-item.pb-1(:href="'#'+ subsection.id" :class="subsection.id") {{subsection.text}}
        .border-btm



</template>

<script>
export default {
  name: "sidenav",
  data() {
    return {
      sections: [
        {
          number: 0,
          id: "intro",
          text: "Introducción"
        },
        {
          number: 1,
          id: "section1",
          text: "Panorama general",
          subsections: [
            {
              number: 0,
              id: "fakeforscrollspy",
              text: "a"
            },
            {
              number: 1,
              id: "subsection1_1",
              text: "Datos oficiales"
            },
            {
              number: 2,
              id: "subsection1_2",
              text: "Cifras reportadas por prensa"
            }
          ]
        },
        {
          number: 2,
          id: "section2",
          text: "Mapa de municipios fosas en la entidad"
        },
        {
          number: 3,
          id: "section3",
          text:
            "Municipios con probabilidades altas de tener fosas aún no localizadas"
        },
        {
          number: 4,
          id: "section4",
          text:
            "Debate sobre fosas clandestinas en Guanajuato, Ley de Búsqueda y desenlaces"
        }
      ]
    };
  },
  methods: {
    onScroll() {
      var prevScrollpos = window.pageYOffset;
      window.addEventListener("scroll", () => {
        const navbar = document.getElementById("mobilenav");
        if (
          document.body.scrollTop > 1300 ||
          document.documentElement.scrollTop > 1300
        ) {
          navbar.style.top = "0";
          let currentScrollPos = window.pageYOffset;
          if (prevScrollpos > currentScrollPos) {
            navbar.style.top = "0";
          } else {
            navbar.style.top = "-100px";
          }
          prevScrollpos = currentScrollPos;
        } else {
          navbar.style.visibility = "-100px";
        }
      });
    }
  },
  mounted() {
    this.onScroll();
  }
};
</script>

<style lang="scss">
#sidenav {
  position: sticky;
  position: -webkit-sticky; /* Safari */
  top: 0rem;
  .fakeforscrollspy {
    display: none;
    visibility: hidden;
  }
  .navbar {
    background-color: #fff;
  }
  .nav-link {
    text-align: end;
    color: #2f2f2f;
    padding: 0.25rem 0;
    //margin-bottom: 0.45rem;
  }
  .nav-link.active {
    background-color: #fcd02f;
  }

  .nav-item {
    width: 200px;
  }
  .border-btm {
    width: 85%;
    height: 1px;
    background-color: #2f2f2f;
    margin-left: auto;
    margin-right: 0;
  }
  .sub {
    font-size: 0.85rem;
  }
}
@media (max-width: 420px) {
  #sidenav {
    .nav-item {
      width: 90%;
    }
    .border-btm {
      width: 90%;
    }
  }
}
</style>
